 
import { cacheJsonToWP, clearJsonFromWP, jsonToData } from 'src/libs/utilities'
import { GET_EXTERNAL_LANDING_ACTION, GET_FB_GOODS_ACTION, GET_LOCAL_LANDING_ACTION, GET_WEBSITE_TAGS, UPDATE_EXTERNAL_LANDING_ACTION } from './actionTypes'
import asyncControllers from './controllers' 
import { defaultLanding } from './interfaces'
import { useLandingStore } from './store'
import { cacheHtmlToWP, clearHtmlToWP } from 'src/libs/utilities/wp/html'


export const actions = (action: string, data: any): Promise<any> =>
{  
    let promise: Promise<any> = new Promise<any>((resolve) => resolve(null) ) 
    switch (action) {
        case GET_LOCAL_LANDING_ACTION:
            promise = new Promise((resolve, reject) => { 
                const url = `/assets/data/landing/src/${data.id}.json`
                const goods = `/assets/data/landing/src/${data.src}.csv`
                asyncControllers(action, {...data, url, goods})
                .then( 
                    (response : any) => { 
                        const history = response.history || []
                        const currentHistoryStep = response.currentHistoryStep || 0
                        delete response.history
                        delete response.currentHistoryStep
                        useLandingStore.setState({ 
                            currentLanding : response,
                            currentSource: [`D:\\new-pe-client\\public\\assets\\data\\landing\\src`, `${data.id}.json`],  
                            history, 
                            currentHistoryStep,
                            isLocal: true,
                        })
                        setTimeout(() => resolve( response ), 400)
                        
                    },                    
                )
                .catch((error: any) => {                        
                    useLandingStore.setState({ 
                        currentLanding : defaultLanding(),
                        currentSource: [`D:\\new-pe-client\\public\\assets\\data\\landing\\src`, `${data.id}.json`]
                    })
                    setTimeout(() => resolve( {} ), 400)
                })
            })
            return promise
        case GET_EXTERNAL_LANDING_ACTION:
            promise = new Promise((resolve, reject) => { 
                const land_id       = data.land_id
                const landing_id    = data.landing_id
                asyncControllers(action, data).then( 
                    (response : any) => { 
                        // console.log( response.data.getPELandingPage.json )
                        const dt = jsonToData(  ( ( response.data.getPELandingPage.json ) ) )
                        // console.log( dt )

                        const history = dt.history || []
                        const currentHistoryStep = dt.currentHistoryStep || 0
                        useLandingStore.setState({ 
                            currentLanding : dt,
                            currentSource: [],  
                            history, 
                            currentHistoryStep,
                            land_id,
                            landing_id,
                            isLocal: false
                        })
                        setTimeout(() => resolve( response ), 400)
                        
                    },
                    (error: any) => reject( error )
                )
            })
            return promise
        case UPDATE_EXTERNAL_LANDING_ACTION:
            promise = new Promise((resolve, reject) => { 
                const json =  ( cacheHtmlToWP( data.input.json ) ) 
                const _data =  {
                    ...data,
                    input: {
                        ...data.input,
                        json: json
                    }
                }
                asyncControllers(action, _data).then( 
                    (response : any) => { 
                        resolve( response )
                    },
                    (error: any) => reject( error )
                )
            })
            return promise
        case GET_FB_GOODS_ACTION:
            promise = new Promise((resolve, reject) => { 
                asyncControllers(action, data).then( 
                    (response : any) => { 
                        resolve( response )
                    },
                    (error: any) => reject( error )
                )
            })
            return promise
        case GET_WEBSITE_TAGS:
            promise = new Promise((resolve, reject) => { 
                asyncControllers(action, data).then( 
                    (response : any) => { 
                        resolve( response.data.getExternalWebsiteTags )
                    },
                    (error: any) => reject( error )
                )
            })
            return promise
        default:
            promise = new Promise((resolve, reject) => { 
                asyncControllers(action, data).then( 
                    (response : any) => { 
                        resolve( response )
                    },
                    (error: any) => reject( error )
                )
            })
            return promise
    } 
} 

export const syncAction = (action: string, data: any): any => {
    switch(action) { 
        default:
            return action
    }
    
}